import ky from "ky";
import { notifyUnauthorizedResponse } from "@features/auth/authSessionHandler";

/** 將 ky 的 HTTPError 轉成接近 axios 的錯誤物件（含 response.data / status） */
export async function toAxiosLikeError(err) {
  if (!err?.response) {
    return err;
  }
  const res = err.response;
  const ct = (res.headers.get("content-type") || "").toLowerCase();
  let data;
  try {
    if (ct.includes("application/json")) {
      data = await res.json();
    } else {
      const blob = await res.blob();
      if (blob.size === 0) {
        data = null;
      } else {
        const text = await blob.text();
        const trimmed = text.trim();
        if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
          try {
            data = JSON.parse(text);
          } catch(err) {
            console.log("Error parsing json", err);
            data = text;
          }
        } else {
          data = text;
        }
      }
    }
  } catch(err) {
    console.log("Error parsing json", err);
    data = null;
  }
  const wrapped = new Error(err.message);
  wrapped.response = {
    data,
    status: res.status,
    statusText: res.statusText,
    headers: res.headers,
  };
  return wrapped;
}

export async function kyFetch(url, options = {}) {
  try {
    const res = await ky(url, options);
    const json = await res.json();
    return {
      data: json,
      status: res.status,
      statusText: res.statusText,
      headers: res.headers,
    };
  } catch (err) {
    const wrapped = await toAxiosLikeError(err);
    notifyUnauthorizedResponse({
      url,
      status: wrapped.response?.status,
      config: options,
    });
    throw wrapped;
  }
}

export async function kyFetchBlob(url, options = {}) {
  try {
    const res = await ky(url, options);
    const blob = await res.blob();
    return {
      data: blob,
      status: res.status,
      statusText: res.statusText,
      headers: res.headers,
    };
  } catch (err) {
    const wrapped = await toAxiosLikeError(err);
    notifyUnauthorizedResponse({
      url,
      status: wrapped.response?.status,
      config: options,
    });
    throw wrapped;
  }
}
